import { Colors } from '../../../theme/colors';

const AuthenticationFormErrorTextStyle = `
  color: ${Colors.salmon};
  margin: 5px 0 15px;
  text-align: center;
`;

export default AuthenticationFormErrorTextStyle;
